import { UserbotCatalog } from "../../interfaces"
import { coerceFieldValue, rawFromFieldValue } from "../fields/fieldSpecCoerce"
import { isRootUnion } from "../fields/fieldSpecVariant"

export const paramsToValues = (
  specs: UserbotCatalog.FieldSpec[],
  params: Record<string, unknown>,
) => {
  if (isRootUnion(specs)) return { value: rawFromFieldValue(specs[0], params) }
  const values = { ...params }
  for (const spec of specs)
    if (spec.key in params)
      values[spec.key] = rawFromFieldValue(spec, params[spec.key])
  return values
}

export const valuesToParams = (
  specs: UserbotCatalog.FieldSpec[],
  values: Record<string, unknown>,
) => {
  if (isRootUnion(specs))
    return coerceFieldValue(specs[0], values.value) as Record<string, unknown>
  const params = { ...values }
  for (const spec of specs) {
    const raw = values[spec.key]
    if (raw === undefined || raw === "") {
      delete params[spec.key]
      continue
    }
    params[spec.key] = coerceFieldValue(spec, raw)
  }
  return params
}
